var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pg-box",style:(("width:" + _vm.tot + "px"))},[_c('div',{ref:"total",staticClass:"total",style:(("width:" + _vm.wVal + "px"))})])}
var staticRenderFns = []

export { render, staticRenderFns }